/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Fri, Jul 23rd 2021, 8:45:47 pm
 *
 * *****************************************************
 */

import { useState, useEffect } from 'react';

import { TextStyle } from '@shopify/polaris';

import { RetryText } from './styles';

/**
 * Content when retrying to get workspace list data
 */
const RetryGetWorkspaces = () => {
  const [timeLeft, setTimeLeft] = useState(5);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft(prevState => (prevState >= 0 ? prevState - 1 : 0));
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <RetryText>
      <TextStyle variation="subdued">Retrieve in {timeLeft} seconds...</TextStyle>
    </RetryText>
  );
};

export default RetryGetWorkspaces;
